export { fetchNextSchedules } from './nextSchedules/fetchNextSchedules'
export { getAddressByCEP } from './getAddressByCEP'
export { getUserData } from './getUserData'
export { updateUserData } from './updateUserData'